import TwoColumn from "./TwoColumn";

export default TwoColumn;
